<template lang="pug">
el-form(ref='application', :inline='true', :inline-message="true", :model='application',
  label-width='160px', :rules='rules', size='small', :disabled="applicationFinalSaved")
  //- el-form-item(v-show='isBachelor' :label="$t('equivalenceorcorrespondence')") 
  //-   el-radio-group(v-model='correspondence', size='small', @change='correspondenceChanged')
  //-     el-radio-button(label='correspondence') {{$t("equivalenceorcorrespondence2")}}
  //-     el-radio-button(label='equality') {{$t("equivalenceofdegree")}}
    el-tooltip(placement='right')
      div(slot='content')
        <p v-html="$t('hint_parity')"></p>
      i.el-icon-question
  //- el-alert(:closable='false' v-if="!applicationFinalSaved && !this.application.correspondence && isBachelor"
  //-    :title="$t('attention')"
  //-   type='error' effect='dark' show-icon='')
  //- el-form-item(v-show='isBachelor' :label="$t('with')")
  //-   el-radio-group(v-model='application.recognitionWith', size='small')
  //-     el-radio-button(label='aeiAndTei') {{$t("uni_tei")}}
  //-     el-radio-button(label='aei') {{$t("university")}}
  //-     el-radio-button(label='tei') {{$t("tei")}}
    el-tooltip(placement='right')
      div(slot='content')
        span {{ $t("hint_aeitei") }}
      i.el-icon-question
  div
    div(v-show="application.degreeType !== 'bachelor'")
      el-form-item(:label="$t('first_bachelor')")
        el-switch(v-model="application.titles.greekBachelor", :active-text="$t('greek_uni')",
          :inactive-text="$t('foreign_uni')", @change='greekBachelorChanged')
      el-form-item(:label="$t('dep_uni')", v-show='application.titles.greekBachelor', prop="titles.greekBachelorInserted")
        el-input.biggest(v-model='application.titles.greekBachelorInserted',  @change="fieldChanged",
        @input="application.titles.greekBachelorInserted = application.titles.greekBachelorInserted.toUpperCase()")
      el-form-item(:label="$t('rec_act')", v-show='!application.titles.greekBachelor' prop='titles.greekBachelorInserted')
        el-input(v-model='application.titles.greekBachelorInserted',  @change="fieldChanged")
    div
      hr
      b {{$t("titleforrec")}}
      type-of-study(
        :fromConsideration="fromConsideration",
        :title="application.titles",
        @typeOfStudyChanged="fieldChanged"
      )
  title-details(
    :fromConsideration="fromConsideration",
    :title="application.titles",
    :countries="countries",
    :applicationFinalSaved="applicationFinalSaved",
    @titleDetailsChanged="fieldChanged"
  )
  div(v-if="isBachelor")
    el-form-item(:label="$t('coevaluation')" v-if="application.consideration === true" )
      el-checkbox(name='synektimisi', v-model='application.consideration',
      @change="considerOtherTitles", disabled)
    el-tooltip(placement='right', v-show="application.consideration")
      div(slot='content')
        span {{ $t("coevaluation_check") }}
      i.el-icon-question
    hr
    //- correspondence(
    //-   :application="application",
    //-   :greekUniversityDepartments='greekUniversityDepartments',
    //-   :greekTeiDepartments='greekTeiDepartments'
    //-   @titlesCorrespondenceChanged="fieldChanged"
    //- )
    correspondence(
      :application="application",
      :allDepartments='allDepartments'
      @titlesCorrespondenceChanged="fieldChanged"
    )
</template>

<script>
import sharedMethods from './sharedMethods.js'
import correspondence from './correspondence'
import typeOfStudy from './typeOfStudy'
import titleDetails from './titleDetails'

export default {
  components: {
    correspondence,
    typeOfStudy,
    titleDetails,
  },
  mixins: [sharedMethods],
  props: [
    'application',
    'countries',
    // 'greekUniversityDepartments',
    'allDepartments',
    // 'greekTeiDepartments',
    'applicationFinalSaved',
    'isBachelor',
    'checkFormTitles',
  ],
  mounted() {
    if (this.application.correspondence === null) {
      this.application.correspondence = false
    }
    if (this.application.titles.greekBachelor === null) {
      this.application.titles.greekBachelor = false
    }
  },
  data() {
    return {
      fromConsideration: false,
      formValidation: false,
    }
  },
  computed: {
    rules() {
      if (this.formValidation) {
        return {
          'titles.cityOfStudiesGr': [
            {
              required: this.application.titles.partOfStudiesGr,
              message: this.$t('studyCitySelectMsg'),
              trigger: 'change',
              max: 100,
            },
          ],
          'titles.institutionOfStudiesGr': [
            {
              required: this.application.titles.partOfStudiesGr,
              message: this.$t('institutionSelectMsg'),
              trigger: 'change',
              max: 150,
            },
          ],
          'titles.country.name': [
            {
              required: true,
              message: this.$t('studyCountrySelectMsg'),
              trigger: 'change',
              max: 100,
            },
          ],
          'titles.country.countryInserted': [
            {
              required: this.application.titles.country.name === 'other',
              message: this.$t('studyCountryInsertMsg'),
              trigger: 'change',
              max: 100,
            },
          ],
          'titles.university.name': [
            {
              required: true,
              message: this.$t('universitySelectMsg'),
              trigger: 'change',
              max: 150,
            },
          ],
          'titles.university.universityInserted': [
            {
              required: this.application.titles.university.name === 'other',
              message: this.$t('universityInsertMsg'),
              trigger: 'change',
              max: 150,
            },
          ],
          'titles.certificationTitle': [
            {
              required: true,
              message: this.$t('titleInsertMsg'),
              trigger: 'change',
              max: 200,
            },
          ],
          'titles.credits': [
            {
              type: 'number',
              required: true,
              message: this.$t('ectsInsertMsg'),
              max: 1000,
              trigger: 'change',
            },
          ],
          'titles.dateOfRegistration': [
            {
              required: true,
              message: this.$t('startDateSelectMsg'),
              trigger: 'change',
              max: 100,
            },
          ],
          'titles.dateOfGraduation': [
            {
              required: true,
              message: this.$t('graduationDateSelectMsg'),
              trigger: 'change',
              max: 100,
            },
          ],
          'titles.durationOfStudies': [
            {
              required: true,
              message: this.$t('durationSelectMsg'),
              trigger: 'change',
              max: 100,
            },
          ],
          'titlesCorrespondence.universityDepartment.name': [
            {
              required:
                this.application.recognitionWith === 'aei' ||
                this.application.recognitionWith === 'aeiAndTei',
              message: this.$t('departmentSelectMsg'),
              trigger: 'change',
              max: 200,
            },
          ],
          'titlesCorrespondence.TEIDepartment.name': [
            {
              required:
                this.application.recognitionWith === 'tei' ||
                this.application.recognitionWith === 'aeiAndTei',
              message: 'Παρακαλώ επιλέξτε το τμήμα ΤΕΙ για αντιστοιχία',
              trigger: 'change',
              max: 200,
            },
          ],
          'titles.greekBachelorInserted': [
            {
              required:
                this.application.degreeType === 'master' ||
                this.application.degreeType === 'phd',
              message: this.$t('fieldRequiredMsg'),
              trigger: 'change',
              max: 150,
            },
          ],
        }
      } else {
        return null
      }
    },
    correspondence: {
      get: function() {
        return this.application.correspondence ? 'correspondence' : 'equality'
      },
      set: function(val) {
        this.correspondenceChanged(val)
      },
    },
  },
  methods: {
    correspondenceChanged(correspondence) {
      this.application.correspondence = correspondence === 'correspondence'
    },
    checkForm() {
      this.$refs['application'].validate(valid => {
        if (valid) {
          this.titlesValid = true
          this.$emit('titlesValidEvent', this.titlesValid)
        } else {
          this.titlesValid = false
          this.$emit('titlesValidEvent', this.titlesValid)
        }
      })
    },
    greekBachelorChanged() {
      this.application.titles.greekBachelorInserted = ''
    },
    fieldChanged(el) {
      this.formValidation ? this.checkForm() : console.log('first visit')
      this.$emit('titlesChanged', this.application.titles)
    },
    considerOtherTitles() {
      this.$emit('consider-other-titles', this.application.consideration)
      this.$emit('titlesChanged', this.application.titles)
    },
  },
  watch: {
    checkFormTitles: function(newData, oldData) {
      this.formValidation = true
      this.checkForm()
    },
    application: {
      handler: function(newVal, oldVal) {
        if (newVal.titles.greekBachelor === null) {
          this.application.titles.greekBachelor = false
        }
      },
      deep: true,
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../styles/variables.scss';

.el-input {
  width: 240px;
}
.el-autocomplete {
  width: 440px;
}
.my-autocomplete {
  li {
    line-height: normal;
    padding: 3px;

    .value {
      text-overflow: clip;
      font-size: 9px;
      overflow: hidden;
      color: #6d728b;
      white-space: normal;
    }
    .link {
      text-overflow: clip;
      font-size: 10px;
      color: #33408a;
      white-space: normal;
    }
  }
}
// @media only screen and (min-width: $screen-sm-min) {
//   .maxSteps {
//     display: none;
//   }
// }
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 190px;
}
.el-input {
  &.big {
    width: 440px;
  }
  &.biggest {
    width: 540px;
  }
}
.el-textarea {
  &.biggest {
    width: 540px;
  }
}
.el-select {
  &.big {
    width: 440px;
  }
  &.biggest {
    width: 1100px;
  }
  &.countries {
    width: 440px;
  }
}
.hideSMup {
  display: none;
}
.hideSMdown {
  display: block;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 180px;
}
.el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #1b91de;
}

@media only screen and (max-width: $screen-sm-min) {
  .hideSMup {
    display: block;
  }
  .hideSMdown {
    display: none;
  }
  .el-autocomplete {
    width: 240px;
  }
  .el-input {
    &.big {
      width: 240px;
    }
    &.biggest {
      width: 240px;
    }
  }
  .el-select {
    &.countries {
      width: 240px;
    }
    &.big {
      width: 240px;
    }
    &.biggest {
      width: 240px;
    }
  }
}
</style>
